import { forwardRef, type Ref, type SVGProps } from "react";
const IconArrowLeftCircleOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M15.8 23.7a1 1 0 0 0 0-1.5L10.5 17H24a1 1 0 0 0 0-2H10.5l5.3-5.2a1 1 0 0 0 0-1.5 1 1 0 0 0-1.5 0l-7 6.9a1 1 0 0 0-.3.8 1.1 1.1 0 0 0 .3.8l7 6.9a1 1 0 0 0 1.5 0"
    />
    <path
      fill="currentColor"
      d="M16 4a12 12 0 1 1 0 24 12 12 0 0 1 0-24m0-2a14 14 0 1 0 0 28 14 14 0 0 0 0-28"
    />
  </svg>
);
const ForwardRef = forwardRef(IconArrowLeftCircleOutlineSVG);
ForwardRef.displayName = "IconArrowLeftCircleOutline";
export { ForwardRef as IconArrowLeftCircleOutline };
